export default {
  scheduled_order: 'Planlagt bestilling',
  show_more: 'Vis mere',
  show_less: 'Vis mindre',
  schedule_order: 'Planlæg bestilling',
};
